import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const { FiMenu, FiX } = FiIcons;
  const logoUrl = "https://i.postimg.cc/PJHcFz0Z/Profit-Lense-Ai-removebg-preview.png";

  return (
    <nav className="fixed top-0 left-0 right-0 z-[100] bg-navy-nav/80 backdrop-blur-2xl border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        {/* Logo Section */}
        <div className="flex items-center group cursor-pointer">
          <img 
            src={logoUrl} 
            alt="ProfitLense.ai Logo" 
            className="h-12 md:h-16 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
          />
        </div>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8">
          <a href="#" className="text-sm font-medium text-text-body hover:text-white transition-colors">Features</a>
          <a href="#" className="text-sm font-medium text-text-body hover:text-white transition-colors">Pricing</a>
          <a href="#" className="text-sm font-medium text-text-body hover:text-white transition-colors">Guides</a>
          <a href="https://profitlense.ai/contact-us/" className="text-sm font-bold text-white bg-brand-secondary/10 hover:bg-brand-secondary/20 border border-brand-secondary/30 px-6 py-2.5 rounded-xl transition-all shadow-lg shadow-brand-secondary/10">
            Get Support
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className="md:hidden text-white p-2"
          onClick={() => setIsOpen(!isOpen)}
        >
          <SafeIcon icon={isOpen ? FiX : FiMenu} className="text-2xl" />
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div className="md:hidden bg-navy-deep border-b border-white/10 px-4 py-6 space-y-4 animate-in slide-in-from-top duration-300">
          <a href="#" className="block text-lg font-medium text-text-body hover:text-white">Features</a>
          <a href="#" className="block text-lg font-medium text-text-body hover:text-white">Pricing</a>
          <a href="#" className="block text-lg font-medium text-text-body hover:text-white">Guides</a>
          <a href="https://profitlense.ai/contact-us/" className="block w-full text-center py-4 bg-brand-secondary/20 text-white rounded-xl border border-brand-secondary/40 font-bold">
            Get Support
          </a>
        </div>
      )}
    </nav>
  );
}